import { render, staticRenderFns } from "./TaskTemplate.vue?vue&type=template&id=5ed3bdb2"
import script from "./TaskTemplate.vue?vue&type=script&lang=js"
export * from "./TaskTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports